module.exports = __webpack_public_path__ + "quilt3-level5.cca19baf.png";